export default __webpack_public_path__ + "media/images/react_icons/property/ac_unit-66e616b0d38db6cb291168769bb4e806.svg";